import React, { FC, useEffect, useRef, useState } from "react";
import { Field, Persona } from "@fluentui/react-components";
import type {
  InputOnChangeData,
  PersonaProps,
  SearchBoxChangeEvent,
} from "@fluentui/react-components";

import {
  Popover,
  PopoverSurface,
  PositioningImperativeRef,
  Spinner,
} from "@fluentui/react-components";
import { EmailAddress } from "@/view/addin/settings/assistant-org/Models";
import { useTranslation } from "react-i18next";
import { SearchBox } from "@fluentui/react-components";

import { List, ListItem } from "@fluentui/react-migration-v0-v9";
import { EAlignment, EPosition } from "../TreeSelect/Models";

export interface IItemAOProps {
  Email: string;
  Name: string;
}

export interface SearchProps {
  listData: any[] | [];
  defaultAssistant?: string;
  onChange: (val: string) => void;
  onSelect?: (item: IItemAOProps | undefined) => void;
  placeholder: string;
  isFindColleague?: boolean;
  currentUser?: EmailAddress;
  isLoading?: boolean;
}

export const SearchFindColleague: FC<SearchProps> = ({
  listData,
  defaultAssistant,
  onChange,
  onSelect,
  placeholder,
  isFindColleague,
  currentUser,
  isLoading,
}) => {
  const { t } = useTranslation();

  // const originalItems = useConst(() => createListItems(10));
  const [items, setItems] = useState<any>([]);
  const [showList, setShowList] = useState(false);
  const [valueSearch, setValueSearch] = useState(defaultAssistant);
  const wrapperRef = React.useRef(null);

  useEffect(() => {
    if (listData) {
      setItems(listData);
    } else {
      setItems([]);
    }
  }, [listData]);

  useEffect(() => {
    if (valueSearch !== currentUser?.Email) {
      setValueSearch(currentUser?.Email || "");
    }
  }, [currentUser?.Email]);

  const onFilterChanged = (
    event: SearchBoxChangeEvent,
    data: InputOnChangeData
  ): void => {
    setItems([]);
    const textSearch = data?.value ? data?.value : "";
    setValueSearch(textSearch);
    onChange(textSearch);
    if (textSearch.length > 0) {
      setShowList(true);
    } else {
      setShowList(false);
    }
  };

  const onSelectItem = (item: IItemAOProps | undefined) => {
    onSelect && onSelect(item);
    setValueSearch(item?.Email || "");
    setShowList(false);
  };

  const onRenderCell = (
    item: IItemAOProps | undefined,
    index: number | undefined
  ): JSX.Element => {
    const examplePersona: PersonaProps = {
      avatar: "",
      name: item?.Name,
      secondaryText: item?.Email,
      textAlignment: "start",
    };

    return (
      <div
        className="ao-box-section"
        data-is-focusable={true}
        onClick={() => {
          onSelectItem(item);
        }}
      >
        <Persona {...examplePersona} size="small" />
      </div>
    );
  };

  const getWithElement = (): number => {
    const el = document.getElementById(`select_context_search_Find_colleague`);
    //console.log("el?.offsetWidth", el?.offsetWidth);
    return el?.offsetWidth ? el.offsetWidth : 0;
  };

  const [open, setOpen] = useState(false);

  const positioningRef = useRef<PositioningImperativeRef>(null);

  return (
    <div
      ref={wrapperRef}
      style={{ position: "relative", width: "100%", maxWidth: "100%" }}
    >
      <Field
        label={
          <div className="rf-settings-content-row-title">
            Assistant organizer
          </div>
        }
        size="medium"
      >
        <SearchBox
          value={valueSearch}
          autoComplete="off"
          placeholder={t(placeholder)}
          onChange={onFilterChanged}
          style={{ width: "100%", maxWidth: "100%" }}
        />
      </Field>
      <Popover
        onOpenChange={(_, data) => setOpen(data.open)}
        trapFocus
        open={open}
        positioning={{
          positioningRef,
          position: EPosition.BELOW,
          align: EAlignment.START,
        }}
        mountNode={undefined}
      >
        <PopoverSurface
          aria-labelledby={"xxxxx"}
          className="width_custom_popover"
          style={{
            maxHeight: "300px",
            overflow: "auto",
            minWidth: getWithElement() - 12,
            padding: "4px",
          }}
        ></PopoverSurface>
      </Popover>

      {/* <ContextualMenu
        items={menuItemsNotSearch}
        hidden={!showList}
        target={wrapperRef}
        onDismiss={() => setShowList(false)}
        className="custom-context"
        styles={{
          root: {
            background: "#ffffff",
            border: "transparent",
          },
        }}
        calloutProps={{
          styles: {
            root: {
              zIndex: 1,
              width: getWithElement(),
            },
            calloutMain: { overflow: "hidden", opacity: 1 },
          },
        }}
        isBeakVisible={false}
      /> */}
    </div>
  );
};
